import {useEffect} from "react";
import Header from "components/Header/Header";
import ChargeBackDispute from "components/ChargeBackDispute/ChargeBackDispute";

const MainPage = () => {

  useEffect(() => {
    const now = new Date().getTime();
    const pageLoadTime = now - performance?.timing?.navigationStart;
    console.log("User-perceived page loading time: " + pageLoadTime);
  }, []);

  return (
    <>
      <Header />
      <ChargeBackDispute />
    </>
  )
}

export default MainPage;
